import React, { useState, useEffect } from "react";
import IndexAbout from "./index/IndexAbout";
import IndexMainArea from "./index/IndexMainArea";
import IndexContentArea from "./index/IndexContentArea";
import IndexProducts from "./index/IndexProducts";
import IndexFunctions from "./index/IndexFunctions";
import { useNavigateState } from "ellipse/navigate/NavigateState";
import { Navigate } from "ellipse/navigate/Navigate";
import { IServerInformationManager } from "./../services/IServerInformationManagerInterop";

export interface IndexProps {}

const Index: React.FC<IndexProps> = (props: IndexProps) => {

	const { url, setUrl } = useNavigateState();
	const [page, setPage] = useState<string>("about");

	const ping = async () => {
		const service: IServerInformationManager = new IServerInformationManager();
		service.serverTime();
	};

	useEffect(() => {
		let pageId = Navigate.queryObject().page;
		if (pageId === undefined) {
			pageId = "about";
		}
		setPage(pageId);
	}, [url]);

	useEffect(() => {
		ping();
		setUrl(Navigate.url());
	}, []);

	return (
		<div id="index-main" className="md:grid md:grid-cols-[auto_1fr] md:h-screen">
			<IndexMainArea />
			<IndexContentArea>
				{page === "about" && <IndexAbout />}
				{page === "products" && <IndexProducts />}
				{page === "services" && <IndexFunctions />}
			</IndexContentArea>
		</div>
	);

};

export default Index;